import { Reducer, AnyAction } from 'redux';
import { getStore, ShimmedConnection } from '@/store';

export const OWC_PERSONALISATION_CONNECTION = 'OWC_PERSONALISATION_DATA';

export enum dispatchers {
  addPersonalisationData = 'addPersonalisationData',
  addItemsToShow = 'addSliderItems',
}

export enum stateProps {
  data = 'personalisationData',
  itemsToShow = 'itemsToShow',
}

export type OWCPersonalisationState = (OWCPersonalisationData & OWCSliderItems)[];

export type OWCPersonalisationData = {
  [key: string]: unknown;
  componentId: string;
  personalisationData: Record<string, unknown>;
};

export type OWCSliderItems = {
  [key: string]: string | Array<string>;
  componentId: string;
  itemsToShow: Array<string>;
};

const initialState: OWCPersonalisationState = [];

export type OWCPersonalisationDispatchers = {
  addPersonalisationData: (data: OWCPersonalisationData) => AnyAction;
  addItemsToShow: (data: OWCSliderItems) => AnyAction;
};

export const getPersonalisationConnection = async () => {
  const shimmedConnection = new ShimmedConnection<OWCPersonalisationDispatchers, OWCPersonalisationState>(
    OWC_PERSONALISATION_CONNECTION,
    initialState,
  );

  const dispatchersToSet: any = {
    addPersonalisationData: async (payload: OWCPersonalisationData) =>
      await shimmedConnection.getAction(dispatchers.addPersonalisationData, payload),
    addItemsToShow: async (payload: OWCSliderItems) =>
      await shimmedConnection.getAction(dispatchers.addItemsToShow, payload),
  };

  const buildReducer = async (): Promise<Reducer> => {
    const addPersonalisationDataActionType = await shimmedConnection.getActionType(
      dispatchers.addPersonalisationData,
    );
    const addItemsToShowActionType = await shimmedConnection.getActionType(dispatchers.addItemsToShow);

    return (state: OWCPersonalisationState, action: AnyAction) => {
      if (action.type === addPersonalisationDataActionType) {
        state = [action.payload];
        return [...state];
      } else if (action.type === addItemsToShowActionType) {
        const existingItem = state.find(item => item.componentId === action.payload.componentId);
        if (existingItem) {
          const itemsToShow = [
            ...existingItem[stateProps.itemsToShow],
            ...action.payload[stateProps.itemsToShow],
          ];
          const newitemsToShow = itemsToShow.filter((el, index) => itemsToShow.indexOf(el) === index);
          existingItem[stateProps.itemsToShow] = newitemsToShow;
        } else {
          state.push(action.payload);
        }
        return [...state];
      }
      return state;
    };
  };

  const reducerToSet = await buildReducer();

  shimmedConnection.setDispatchers(dispatchersToSet);
  shimmedConnection.setReducer(reducerToSet);
  return await shimmedConnection.getConnection();
};

export const addPersonalisationConnection = async () => {
  const OWCPersonalisationConnection = await getPersonalisationConnection();
  (await getStore()).addConnection(OWCPersonalisationConnection);
};
